import {
  SplitSupplyOwnNoticeImportPointKind,
  SplitSupplyOwnNoticeSkipReason,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_model_pb'

import { issueReasonKeys } from '~/pages/SplitSupplyPlan/models/noticeImport'

/**
 * 自社の通告値の取込の画面側の決まり (文言の対応)。 ファイルの選択状態など他社の取込と共通のものは
 * `noticeImport.ts`。 読み取り・突合・誤りの判定は backend が持つ。
 */

export const OWN_IMPORT_KEY_PREFIX = 'page:splitSupplyPlan.own.import' as const

const KEY_PREFIX = OWN_IMPORT_KEY_PREFIX

/** 地点ごとの取り込み方 (新規 / 上書き) → 文言の key。 */
export const OWN_POINT_KIND_KEYS: Record<
  SplitSupplyOwnNoticeImportPointKind,
  string | undefined
> = {
  [SplitSupplyOwnNoticeImportPointKind.UNSPECIFIED]: undefined,
  [SplitSupplyOwnNoticeImportPointKind.NEW]: `${KEY_PREFIX}.kind.new`,
  [SplitSupplyOwnNoticeImportPointKind.OVERWRITE]: `${KEY_PREFIX}.kind.overwrite`,
}

/** 取り込まない地点の理由 → 文言の key。 */
export const OWN_SKIP_REASON_KEYS: Record<
  SplitSupplyOwnNoticeSkipReason,
  string | undefined
> = {
  [SplitSupplyOwnNoticeSkipReason.UNSPECIFIED]: undefined,
  [SplitSupplyOwnNoticeSkipReason.NOT_IN_CONTRACT]: `${KEY_PREFIX}.skipped.reason.notInContract`,
  [SplitSupplyOwnNoticeSkipReason.PARTNER_NOTIFIER]: `${KEY_PREFIX}.skipped.reason.partnerNotifier`,
  [SplitSupplyOwnNoticeSkipReason.AREA_MISMATCH]: `${KEY_PREFIX}.skipped.reason.areaMismatch`,
  [SplitSupplyOwnNoticeSkipReason.SENDER_MISMATCH]: `${KEY_PREFIX}.skipped.reason.senderMismatch`,
  [SplitSupplyOwnNoticeSkipReason.LOAD_FOLLOWING_MISMATCH]: `${KEY_PREFIX}.skipped.reason.loadFollowingMismatch`,
}

/** ファイルの誤りの理由 → 文言の key。 */
export const OWN_IMPORT_ISSUE_REASON_KEYS = issueReasonKeys(KEY_PREFIX)
